import { config } from "api/apiRoutes";
import { ShipmentDetailsRequestModel } from "api/lokiRequestModels/shipments/ShipmentDetailsRequestModel";
import { shipmentDetailsList } from "models/shipmentDetails/shipmentDetailsList";
import { RouteShipmentsRequestModel } from "api/lokiRequestModels/shipments/RouteShipmentsRequestModel";
import { ShipmentRequestModel } from "api/lokiRequestModels/shipments/ShipmentRequestModel";
import { ShipmentDetails } from "models/shipmentDetails/ShipmentDetails";
import { lokiAxios } from "api/serviceConfig";

export class ShipmentService {
    async listShipmentsDetails(data: ShipmentDetailsRequestModel) {
        return await lokiAxios.get<shipmentDetailsList>(
            config.laneShipmentsUrl(data.laneId),
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                    lsp: data.lsp,
                    productType: data.productType,
                    riskLevel: data.riskLevel, // change
                    transportationModes: data.transportationModes, // change
                    packagingType: data.packagingType,
                    nextToken: data.nextToken,
                    sort: data.sort,
                    direction: data.direction,
                },
            }
        );
    }

    async allShipmentsDetails(data: ShipmentDetailsRequestModel) {
        return await lokiAxios.get<shipmentDetailsList>(
            config.shipmentsDetails,
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                    lsp: data.lsp,
                    productType: data.productType,
                    riskLevel: data.riskLevel, // change
                    transportationModes: data.transportationModes, // change
                    packagingType: data.packagingType,
                    nextToken: data.nextToken,
                    sort: data.sort,
                    direction: data.direction,
                },
            }
        );
    }

    async getRouteShipments(data: RouteShipmentsRequestModel) {
        return await lokiAxios.get<shipmentDetailsList>(
            config.routeShipmentsUrl(data.routeId),
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                    lsp: data.lsp,
                    productType: data.productType,
                    riskLevel: data.riskLevel, // change
                    transportationModes: data.transportationModes, // change
                    packagingType: data.packagingType,
                    nextToken: data.nextToken,
                    sort: data.sort,
                    direction: data.direction,
                },
            }
        );
    }

    async getShipment(data: ShipmentRequestModel) {
        return await lokiAxios.get<{ shipmentDetails: ShipmentDetails }>(
            config.shipmentUrl(data.id),
            {
                params: {
                    customerId: data.customerId,
                },
            }
        );
    }
}
